var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 633.8 144.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218.68,119.36h-7L205.14,102l-5.42-16.57L194.29,102l-6.49,17.34h-6.91L163,70h8.81l12.55,38,12.76-38h5.07l13,38,12.26-38h8.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M242.64,104.63c.64,5.29,5,8.74,11.35,8.74,3.53,0,8-1.34,10.08-3.74l4.73,4.59c-3.6,3.94-9.59,5.92-15,5.92-11.42,0-18.75-7.26-18.75-18.4,0-10.58,7.4-18.12,18.26-18.12,11.21,0,18.82,6.84,17.48,21Zm21.22-6.13c-.42-5.5-4.44-8.39-10.29-8.39-5.29,0-9.66,2.89-10.79,8.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.75,84.54h7v34.75h-6.9l-.36-5.64c-2.32,4.44-7.68,6.56-12,6.56-10.15.07-17.84-6.49-17.84-18.33,0-11.63,8-18.12,18-18.12,4.93,0,9.66,2.33,11.84,6.28ZM282,101.88c0,7.19,5.07,11.56,11.27,11.56,15,0,15-23,0-23C287.05,90.39,282,94.76,282,101.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M327.79,70v49.27h-7.26V70Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M347.74,74.53V84.61h10.15v6.27H347.67v16.57c0,3.66,1.62,5.71,5,5.71a10.41,10.41,0,0,0,4.44-1.2l2.11,6.2a16.44,16.44,0,0,1-7,1.56c-7.54.21-11.84-4.09-11.84-12.27V90.88h-6.7V84.61h6.7V75.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M371.07,70V89.68A13.14,13.14,0,0,1,382.35,84c9.8,0,14.31,6.56,14.31,16.5v18.75H389.4V100.61c0-6.55-3.38-9.8-8.74-9.8-5.64,0-9.59,4.66-9.59,10.37v18.11h-7.26V70Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M444.66,70c9.38,0,16.78,4.3,16.78,14.09a10.25,10.25,0,0,1-6.84,9.8c5.93,1.77,8.39,7.62,8.39,11.35,0,10.79-8.6,14.1-18.33,14.1H422V70Zm-14.8,20.44h14.88c5.92,0,8.88-2.33,8.88-6.2,0-3.46-3-7.12-9-7.12h-14.8Zm0,21.57h14.8c4.38,0,10.44-1.41,10.44-6.84s-5.85-7.68-10.36-7.68H429.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M476.17,84.54l.5,4.58c2.53-4.44,6.48-5.36,10.22-5.36a13.36,13.36,0,0,1,8.6,3l-3.32,6.35A8.87,8.87,0,0,0,486,91c-5,0-9.37,3.11-9.37,9.52v18.82H469.4V84.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M507.19,74.32c0,6-9,6-9,0S507.19,68.39,507.19,74.32ZM499,84.4v34.89h7.26V84.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M549.69,70v49.27h-6.83l-.43-5.5c-2.75,4.45-7.4,6.21-12,6.21-10.08,0-17.77-6.63-17.77-18.12,0-11.84,7.55-18.12,17.63-18.12,4.23,0,9.94,2.12,12.19,6.21V70Zm-29.82,31.86c0,7,4.87,11.35,11,11.35a11.32,11.32,0,0,0,0-22.63C524.74,90.6,519.87,94.76,519.87,101.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M588,81.23l5.29,4.08-4.16,4.87c2.89,3.38,4.23,6.48,4.23,10.78a13.73,13.73,0,0,1-9.24,13.54c7.12,2.4,9.17,7.19,9.17,11.35,0,9.45-9.31,14.17-18.61,14.17-11.35,0-18.62-5.78-18.33-15.44h7.26c-.21,5.43,5.28,8.32,11.07,8.39,5.35,0,11.06-2.19,11.06-7.12s-4.44-7.54-10.92-7.54c-11.28,0-18.83-6.49-18.83-17.35,0-11.63,9.38-17.48,18.83-17.48,2.89,0,6.91.71,9.37,2.4ZM563.37,101c0,6.91,5.21,10.65,11.49,10.65s11.28-4.37,11.28-10.65c0-6.83-5.29-10.71-11.28-10.71S563.37,93.7,563.37,101Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M605.45,104.63c.63,5.29,5,8.74,11.35,8.74,3.52,0,8-1.34,10.08-3.74l4.72,4.59c-3.59,3.94-9.59,5.92-14.94,5.92-11.42,0-18.76-7.26-18.76-18.4,0-10.58,7.41-18.12,18.26-18.12,11.21,0,18.83,6.84,17.49,21Zm21.22-6.13c-.43-5.5-4.44-8.39-10.3-8.39-5.28,0-9.65,2.89-10.78,8.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.86,44.3,193.67,1,175,1.41,160.86,20.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "102.62 97.08 102.62 41.77 83.29 41.77 60.21 97.68 60.21 41.77 46.74 41.77 46.74 122.27 65.28 122.27 89.16 63.45 89.16 122.27 101.78 122.27 144.48 65.92 144.48 144.48 0 144.48 0 0 144.48 0 144.48 41.77 102.62 97.08"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyLogoWhite);
export default __webpack_public_path__ + "static/media/company-Logo-white.f9f0c55edbeeb135ebf02eccc92f999e.svg";
export { ForwardRef as ReactComponent };